<template>
	<div class="inner-wrapper">
		<div class="h-nav-wrap df">
				<draggable :forceFallback="true" :disabled="!canDrag || popups.addRule.show"
							v-if="user.access_rights.is_owner" element="div"
							v-model="topSections"
							@start="dragStart"
							@end="dragSave"
							:move="dragStatus"
							:animation="150"
							:touchStartThreshold="3"
							:delay="10"
							class="h-nav"
				>
					<div v-for="section in topSections" class="h-nav-item" :key="'top_'+section.id" >
						<div class="">
							<a @click.prevent="goToSection('/settings'+section.id+'/', true)" :href="'/settings'+section.id+'/'" class="i-wrapper edit-top-section" :class="{active: activeSection == section.id && $route.name == 'rules-category-settings' && isActiveMenu}">
								<span class="i i-gear5"></span>
							</a>
							<a @click.prevent="goToSection('/sid'+section.id+'/')" :href="'/sid'+section.id+'/'" class="h-nav-item-link h-link" :class="{active: activeSection==section.id && $route.name != 'rules-category-settings' && isActiveMenu, 'current': section.id == rule.sectionTop}" :to="'/sid'+section.id+'/'">
								<span>{{section.name}}</span>
								<div class="update-notify"  v-if="!isEditing && section.updated && activeSection != section.id"></div>
							</a>
						</div>
					</div>
				</draggable>
				<div class="h-nav" v-else>
					<div v-for="section in topSections" @click="checkIsSearch" class="h-nav-item" :key="'top_'+section.id">
						<router-link class="h-nav-item-link h-link" :class="{active: activeSection == section.id && isActiveMenu, 'current': section.id == rule.sectionTop}" :to="'/sid'+section.id+'/'">
							<span>{{section.name}}</span>
							<div class="update-notify" v-if="!isEditing && section.updated && activeSection!=section.id"></div>
						</router-link>
					</div>
				</div>
				<div class="h-nav" v-if="user.access_rights.is_owner && deactivatedItems > 0 && !tumblers.editable.value">
					<div class="h-nav-item">
						<router-link v-if="user.access_rights.is_owner" :to="'/removed/'" class="h-nav-item-link h-link" :class="{active: $route.name == 'rules-removed'}">
                        	<span>удалённые</span>
                        </router-link>
					</div>
				</div>
				<div v-if="user.access_rights.is_owner && !isSectionDetail" class="add-nav-item__wrap">
					<div class="add-nav-item" @click="openSectionAdd">
						<span class="i i-plus8"></span>
						<span class="i i-plus8-active"></span>
					</div>
				</div>
		</div>
	</div>
</template>
<script>
    import { mapState } from 'vuex'
    import draggable from '@/helpers/vuedraggable.js'
    export default {
        name: "TopSections",
        components: {
            draggable,
        },
        props: {
            return :{
                drag: false,
            },
        },
		data(){
			return {
				prevRoute: false,
			}
		},
        mounted() {
            this.$store.dispatch('rules/getTopSection').then(()=>{
                if (this.$route.params.id == 'lock' && this.$route.params.subid > 0 && this.$route.params.ruleid > 0) {
                    this.$router.push('/sid' + this.topSections[0].id + '/sub' + this.$route.params.subid + '/rule' + this.$route.params.ruleid + '/');
                    this.$store.commit('popups/close', {name: this.popups.somethingWentWrong.name});
                }
            });
        },
        methods: {
			openSectionAdd: function () {
                this.$store.commit('rules/setEditSection',[]);
                this.$store.dispatch('popups/open', {name: this.popups.sectionAdd.name});
            },
            dragSave: function (e) {
                if (this.drag) {
                    this.$store.dispatch('rules/setTopSectionsSort', {});
                    setTimeout(()=>{
                        this.drag = false;
                    },20)
                }
            },
            dragStart: function (e) {
            },
            dragStatus: function (e) {
                this.drag = true;
            },
            goToSection(link, isGoToDetail = false){
                if(!this.drag){
					if(isGoToDetail){
						let sub = this.$route.params.subid ? '/sub' + this.$route.params.subid : false;
						let sid = '/sid'+ this.activeSection;
						let route = sub ? sid + sub : sid;
						this.$store.commit('menus/setPrevRoute', route);
						this.$router.push(link);
					}else{
						this.$router.push(link);
					}
                }
            },
            checkIsSearch() {
                if(this.isSearch) {
                    this.$store.commit('rules/setIsSearch', false);
                    this.$store.commit('popups/close', { name: this.popups.ruleDetail.name });
                }
            },
        },
        computed: {
            ...mapState({
                user: state => state.users.user,
                canDragState: state => state.rules.canDrag,
                isSearch: state => state.rules.isSearch,
                popups: state => state.popups.items,
                rule: state => state.rules.openedRule,
                isLoadItems: state => state.rules.isLoadItems,
                isLoadSections: state => state.rules.isLoadSections,
                sectionsLock: state => state.rules.sectionsLock,
                deactivatedItems: state => state.rules.deactivatedItems,
				tumblers: state => state.rules.tumblers,
                sections: state => state.rules.sections,
            }),
            curTopSection (){
                if(this.topSections[0]){
                    for (let i in this.topSections) {
                        if(this.topSections[i].id == this.activeSection){
                            return this.topSections[i];
                        }
                    }
                    return {};
                }
                else
                    return {};
            },
			isSectionDetail() {
                return this.$route.name === 'rules-category-settings'
            },
            canDrag(){
                if(this.user.access_rights.is_owner || (this.curTopSection && (this.curTopSection.rights == 'W' || this.user.is_chef))) {
                    return this.canDragState
                } else {
                    return false
                }
            },
            isEditing() {
              return this.popups.addRule.show;
            },
            isActiveMenu (){
                return  this.$route.name !== 'screencasts' && this.$route.name != 'moderator-staff' && this.$route.name != 'moderator-staff-detail' && ( this.$route.name == 'rules-removed'  && this.popups.addRule.show || this.$route.name != 'rules-removed' );
            },
            activeSection(){
                if(this.isSearch) return false;
                if(this.is404) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
            is404() {
                let topSection = this.topSections.find(sect => sect.id === this.$route.params.id);
                let subSectionId = false;

               if (this.$route.params.id) {
                    if (topSection) {
                        if (this.$route.params.subid && typeof(topSection.subsections) !== 'undefined') {
                            subSectionId = this.sections.find(sect => sect.id === this.$route.params.subid);
                            
                            if (!subSectionId) {
                                for (const section of this.sections) {
                                    if (section.sections) {
                                        subSectionId = section.sections.find(nestedSect => nestedSect.id === this.$route.params.subid);
                                        if (subSectionId) break;
                                    }
                                }
                            }
                        } else {
                            subSectionId = true;
                        }
                    }
                } else {
                    subSectionId = true;
                }

                //пробуем получить данные, чтобы вызвать ошибку доступа, можно и без запроса, но так надёжнее
                //пока без запроса так
                let noSuccess = false;
                if (typeof this.topSections[0] !== 'undefined') {

                    if (!subSectionId && this.$route.params.id && typeof this.topSections[0].all !== 'undefined') {
                        if (typeof this.topSections[0].all[this.$route.params.id] !== 'undefined') {
                            if (this.$route.params.subid) {
                                if (typeof this.topSections[0].all[this.$route.params.id].find(id => id === this.$route.params.subid) !== 'undefined') {
                                    noSuccess = true;
                                }
                                if (this.sectionsLock.find(item => item.id === this.$route.params.subid)) {
                                    noSuccess = false;
                                }
                            } else {
                                noSuccess = true;
                            }
                        } else {
                            noSuccess = false;
                        }
                    }

                }

                return (this.$route.name === 'page404' || !subSectionId) && !noSuccess && !this.isLoadItems && !this.isLoadSections && !this.sectionsLock.find(item => item.id === this.$route.params.subid);
            },
            topSections: {
                get(){
                    return this.$store.getters['rules/getTopSections']
                },
                set(value){
                    this.$store.commit('rules/setTopSections', {
                        items: value
                    });
                }
            },
            isStaffPage() {
                return this.$route.name === 'moderator-staff' || this.$route.name === 'moderator-staff-detail' || this.$route.name === 'moderator-contract' || this.$route.name === 'moderator-contract-detail';
            },
        }
    }
</script>
